import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api, apiError } from "@/lib/apiClient";
import AuthShell from "@/components/layout/AuthShell";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const [providers, setProviders] = useState([]);
  const orgId = new URLSearchParams(window.location.search).get("org_id") || "";
  const query = orgId ? `?org_id=${encodeURIComponent(orgId)}` : "";
  useEffect(() => { let cancelled = false; api.get(`/auth/sso/providers${query}`).then(({ data }) => { if (!cancelled) setProviders(data.providers); }).catch(() => {}); return () => { cancelled = true; }; }, [query]);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success("Welcome back");
      navigate(user.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) {
      toast.error(apiError(err, "Login failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Sign in"
      subtitle="Access your LiveCore dashboard."
      footer={<>No account? <Link to="/register" className="text-zinc-200 underline underline-offset-4" data-testid="link-register">Create one</Link></>}
    >
      {providers.map((provider) => <a className="mb-3 block rounded border border-zinc-700 p-3 text-center text-sm" key={provider} href={`${api.defaults.baseURL}/auth/sso/${provider}/login${query}`}>Connexion entreprise {provider.toUpperCase()}</a>)}
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <div className="space-y-2">
          <Label htmlFor="email" className="text-zinc-300">Email</Label>
          <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email" className="bg-zinc-950 border-zinc-800" required />
        </div>
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Label htmlFor="password" className="text-zinc-300">Password</Label>
            <Link to="/forgot-password" className="text-xs text-zinc-500 hover:text-zinc-300" data-testid="link-forgot">Forgot?</Link>
          </div>
          <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password" className="bg-zinc-950 border-zinc-800" required />
        </div>
        <Button type="submit" disabled={loading} data-testid="login-submit"
          className="w-full bg-zinc-50 text-zinc-900 hover:bg-zinc-200">
          {loading ? "Signing in…" : "Sign in"}
        </Button>
      </form>
    </AuthShell>
  );
}
